/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Invite_Error_Login_LinkInputs */



/**
* | output |
* | --- |
* | "Go to sign in" |
*
* @param {Partner_Invite_Error_Login_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_invite_error_login_link = /** @type {((inputs?: Partner_Invite_Error_Login_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Invite_Error_Login_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zur Anmeldung")
	return /** @type {LocalizedString} */ ("Go to sign in")
});